import { Badge } from "@devhop/ui";

type DisputeDetailToolbarProps = {
  disputeId: string;
  status: string;
  statusLabel: string;
};

export function DisputeDetailToolbar({
  disputeId,
  status,
  statusLabel,
}: DisputeDetailToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ລາຍລະອຽດຂໍ້ພິພາດ</h2>
        <p className="text-muted-foreground text-sm">ລະຫັດ: {disputeId}</p>
      </div>
      <Badge variant={status === "investigating" ? "secondary" : "outline"}>
        {statusLabel}
      </Badge>
    </div>
  );
}
